import React, {Fragment, useContext} from 'react'
import {AppContext} from '../app/app'
import Config from '../launch/config'

import './css/fleet-list.css'

const FleetList = () => {
    const {
        config,
        setModalContentType,
        toggleGameOverOverlay,
        toggleModal,
    } = useContext(AppContext)

    const filtered = Object.keys(config.ships).filter((key) => {
        const ship = config.ships[key]
        return (
            ship &&
            ship.faction === Config.userFactionName &&
            ship.type !== 'satellite'
        )
    })

    return (
        <Fragment>
            {filtered.map((key, index) => {
                const ship = config.ships[key]
                const {name, orbitingEntity, type} = ship

                return (
                    <div
                        className="fleet-list__item"
                        key={index}
                        onClick={() => {
                            Config.scene.cameras.main.pan(
                                ship.x,
                                ship.y,
                                300,
                                'Linear',
                                true
                            )
                            setModalContentType(null)
                            toggleModal()
                            toggleGameOverOverlay(true)

                            ship.selected = true
                            Config.selectedShips[ship.id] = ship.name
                        }}
                    >
                        {type === 'satellite' && (
                            <img
                                alt="resources"
                                className="fleet-list__icon"
                                src={`${process.env.PUBLIC_URL}/img/satellite-white.png`}
                            />
                        )}
                        {type === 'ship' && (
                            <img
                                alt="resources"
                                className="fleet-list__icon fleet-list__icon--ship"
                                src={`${process.env.PUBLIC_URL}/img/ship-white.png`}
                            />
                        )}

                        {name}

                        {orbitingEntity && (
                            <Fragment>
                                <div className="fleet-list__orb" />
                                <span>Orbiting {orbitingEntity.name}</span>
                            </Fragment>
                        )}
                    </div>
                )
            })}
        </Fragment>
    )
}

export default FleetList
